import { FC } from "react";
import InnerPage from "../../shared/components/InnerPage";
import { PATHS } from "../../paths";

const AboutPage: FC = () => (
  <InnerPage
    eyebrow="Kurumsal"
    title="Securitas İtfaiye"
    crumbs={[{ label: "Hakkımızda", to: PATHS.about }, { label: "Securitas İtfaiye" }]}
    seoDescription="Securitas İtfaiye Hizmetleri, 2011'den bu yana sertifikalı ekipleri ve uluslararası standartlara uygun eğitim programlarıyla sanayi, lojistik ve kurumsal tesislerde 7/24 hizmet verir."
  >
    <div className="it-prose">
      <h2>Securitas İtfaiye</h2>
      <p>
        Securitas, <b>44 ülkedeki global gücünü yerel uzmanlıkla birleştirerek</b>{" "}
        2011 yılında Türkiye'de Securitas İtfaiye Hizmetleri yapılanmasını hayata
        geçirmiştir.
      </p>
      <p>
        2014'te ilk ekibini görevlendiren Securitas, yangın risklerini minimize
        etmeyi ve acil durumlara etkin müdahaleyi önceliklendirerek büyümesini
        sürdürmüştür. 2017'de Securitas Güvenlik Görevlilerini eğiterek{" "}
        <b>Multi Rol Güvenlik Görevlisi</b> formatına dönüştürmüş, böylece yangın
        güvenliği ve güvenlik çözümlerini tek çatı altında entegre etmiştir.
      </p>
      <p>
        Bugün Securitas İtfaiye, sertifikalı ekipleri ve uluslararası standartlara
        uygun eğitim programlarıyla sanayi, lojistik ve kurumsal tesislerde 7/24
        hizmet vermektedir.
      </p>
    </div>
    <div className="it-photo it-photo--tall">
      <img
        src="/uploads/site/hakkimizda-ekip.jpg"
        alt="Securitas itfaiye ekibi hortumla müdahale ediyor"
      />
    </div>
  </InnerPage>
);

export default AboutPage;
